import { useUserApi } from '@/features/users';
// eslint-disable-next-line no-restricted-imports
import { SettingsAddAddressBookModal } from '@/features/users/components';
import { useFetchUser } from '@/hooks';
import type { IAddressBook, IAuthSignupFields } from '@/types';
import { Flex, Icon, Modal, Text, useDisclosure } from '@chakra-ui/react';
import { MbeAdd } from '@/components/icons';
import { useTranslation } from 'react-i18next';

interface IAddDeliveryAddressProps {
  onClose?: () => void;
}

export const AddDeliveryAddress: React.FC<IAddDeliveryAddressProps> = ({
  onClose,
}): JSX.Element => {
  const { fetch: updateUser, user } = useFetchUser();
  const { t } = useTranslation();

  const {
    isOpen: isOpenAddressBook,
    onClose: onCloseAddressBook,
    onOpen: onOpenAddressBook,
  } = useDisclosure();

  const userApi = useUserApi();

  const handleSettingAddressBook = async (data: IAddressBook): Promise<void> => {
    if (user) {
      const updatedUser: IAuthSignupFields = {
        ...user,
        deliveryAddressBook: [...user.deliveryAddressBook, data],
      };

      await userApi.updateUser(updatedUser);
      updateUser();
    }

    onCloseAddressBook();

    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      <Flex alignItems="center" cursor="pointer" h={16} mb={4} onClick={onOpenAddressBook}>
        <Icon as={MbeAdd} h={8} w={10} />
        <Text color="brand.red.light">{t('WIZARD.SHIPPING.ADD_NEW_ADDRESS')}</Text>
      </Flex>
      <Modal
        isOpen={isOpenAddressBook}
        onClose={(): void => {
          onCloseAddressBook();
        }}
      >
        {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
        <SettingsAddAddressBookModal onClick={handleSettingAddressBook} />
      </Modal>
    </>
  );
};
